export default [
	'Africa', 
	'Europe and the Middle East',
	'North America',
	'Central and South America', 
	'Asia & Oceania'
]